declare global {
  interface Window {
    google?: {
      accounts: {
        oauth2: {
          initTokenClient: (config: {
            client_id: string;
            scope: string;
            callback: (response: { access_token?: string; error?: string }) => void;
          }) => { requestAccessToken: () => void };
        };
      };
    };
  }
}

const GIS_SCRIPT_URL = 'https://accounts.google.com/gsi/client';

const CLIENT_ID = '1068953659477-jkdd39bairtvfus4lo5sn00ljv8kokrr.apps.googleusercontent.com';
const SCOPE = 'openid profile email';

let scriptLoaded = false;

export function loadGisScript(): Promise<void> {
  if (scriptLoaded && window.google?.accounts) return Promise.resolve();

  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${GIS_SCRIPT_URL}"]`)) {
      const check = setInterval(() => {
        if (window.google?.accounts) {
          clearInterval(check);
          scriptLoaded = true;
          resolve();
        }
      }, 50);
      setTimeout(() => {
        clearInterval(check);
        reject(new Error('GIS script load timeout'));
      }, 10_000);
      return;
    }

    const script = document.createElement('script');
    script.src = GIS_SCRIPT_URL;
    script.async = true;
    script.onload = () => {
      scriptLoaded = true;
      resolve();
    };
    script.onerror = () => reject(new Error('Failed to load Google Identity Services'));
    document.head.appendChild(script);
  });
}

/**
 * Open Google sign-in popup via Google Identity Services.
 * Returns the Google access token directly — no redirect needed.
 */
export async function loginWithGoogle(): Promise<string> {
  await loadGisScript();

  return new Promise((resolve, reject) => {
    if (!window.google?.accounts) {
      reject(new Error('Google Identity Services not available'));
      return;
    }
    const client = window.google.accounts.oauth2.initTokenClient({
      client_id: CLIENT_ID,
      scope: SCOPE,
      callback: (response) => {
        if (response.error === 'access_denied' || response.error === 'popup_closed_by_user') {
          // User dismissed the popup — treat as a clean cancellation
          reject(new Error('login_cancelled'));
          return;
        }
        if (response.error) {
          reject(new Error(`Google login failed: ${response.error}`));
          return;
        }
        if (!response.access_token) {
          reject(new Error('No access token received from Google'));
          return;
        }
        resolve(response.access_token);
      },
    });

    client.requestAccessToken();
  });
}
